import * as React from 'react'
import { observer, inject } from 'mobx-react'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import {
    getQuestionnairesTableInProgressByCreditConsultant,
    getQuestionnairesTableDraft,
    getQuestionnairesTableScored,
    getQuestionnairesTableInProgressByCreditExpert
}
    from '../../../Model/QuestionnaireTableModel'
import HttpActionsService from '../../../Services/HttpActionsService'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'
import UserStore from '../../../Stores/UserStore'

export interface IQuestionnairesPageProps {
    questionnairesStore?: QuestionnairesStore
    httpActionsService?: HttpActionsService
    userStore?: UserStore
}

@inject('httpActionsService')
@inject('questionnairesStore')
@inject('userStore')
@observer
export default class QuestionnairesPage extends React.Component<IQuestionnairesPageProps> {

    // intervalID: any;

    //   componentDidMount() {
    //     /*
    //       need to make the initial call to getData() to populate
    //      data right away
    //     */
    //     /*
    //       Now we need to make it run at a specified interval,
    //       bind the getData() call to `this`, and keep a reference
    //       to the invterval so we can clear it later.
    //     */
    //     this.intervalID = setInterval(() => {
    //        window.location.reload();

    //       }, 15000);
    //   }

    //   componentWillUnmount() {
    //     /*
    //       stop getData() from continuing to run even
    //       after unmounting this component
    //     */
    //     clearInterval(this.intervalID);
    //   }

    render() {
        const { userStore } = this.props
        return (
            <div className="questionnairesPage row pageCol-6">
                <div className="col-12">
                    <PageSizeComponent />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <ExportToCsvComponent
                        exportType={userStore!.checkCreditConsultant ? ExportType.QDraft : ExportType.QScored}
                    />
                    {
                        userStore!.checkCreditConsultant ?
                            getQuestionnairesTableDraft() :
                            getQuestionnairesTableScored()
                    }
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <ExportToCsvComponent
                        exportType={
                            userStore!.checkCreditConsultant ?
                                ExportType.QInProgressCreditConsultant :
                                ExportType.QInProgressCreditExpert
                        }
                    />
                    {
                        userStore!.checkCreditConsultant ?
                            getQuestionnairesTableInProgressByCreditConsultant() :
                            getQuestionnairesTableInProgressByCreditExpert()
                    }
                </div>
                {/* <div className="tip">
                    <em>{ls.t('Tip: Hold shift when sorting to multi-sort!')}</em>
                </div> */}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Questionnaire/QuestionnairesPage.tsx